import { DateTime } from "luxon";
import { GrTrigger } from "react-icons/gr";
import { GrAction } from "react-icons/gr";
import { IoMdStopwatch } from "react-icons/io";
import IconType from "react-icons";
import locale from "../constants/locale";

export type JourneyCategory = {
  id?: number;
  name: string;
};

export type JouneryStepAnalytics = {
  node_id: string;
  total_reached: number;
  total_proceeded: number;
  completion_rate: string;
  drop_off_rate: string;
};

export type Journey = {
  id?: number;
  categoryId: number;
  userId: string;
  name: string;
  status: "draft" | "published";
  draftData: any;
  publishedData: any;
  eventsCount: number;
  completionRate?: number;
  analytics?: Record<string, JouneryStepAnalytics>;
  isActive: boolean;
  archived: boolean;
  createdAt: DateTime;
  updatedAt: DateTime;
};

export type JourneyEvent = {
  id?: number;
  status: "in-progress" | "completed" | "failed";
  journeyData: Record<string, any>;
  meta: Record<string, any>;
  failedReason?: string;
  createdAt: DateTime;
  updatedAt: DateTime;
  logs?: JourneyEventLog[];
};

export type JourneyEventLog = {
  id: number;
  node: {
    id: string;
    label: string;
  };
  level: string;
  content: string;
  meta?: any;
  createdAt: string;
  updatedAt: string;
};

export type JourneyLog = {
  id?: number;
  content: string;
  meta: {
    last_version?: Journey;
    current_version?: Journey;
  };
  createdAt: DateTime;
  updatedAt: DateTime;
};

export const journeyStatusMap = {
  "in-progress": locale.inProgress,
  completed: locale.completed,
  failed: locale.failed,
};

export type JourneyNodes = {
  triggers?: any[];
  actions?: any[];
  delays?: any[];
  logics?: any[];
};

enum Cases {
  IF = "if",
  AND = "and",
  OR = "or",
}

export const journeyCasesMap: Record<Cases, string> = {
  [Cases.IF]: locale.if,
  [Cases.AND]: locale.and,
  [Cases.OR]: locale.or,
};

export const journeyNodeIcon = {
  trigger: GrTrigger,
  action: GrAction,
  delay: IoMdStopwatch,
} as Record<string, IconType.IconType>;

export type JouneryCard = {
  id: number;
  name: string;
  type: string;
};
